import { render, staticRenderFns } from "./LabVideo.vue?vue&type=template&id=1283d173&"
import script from "./LabVideo.vue?vue&type=script&lang=js&"
export * from "./LabVideo.vue?vue&type=script&lang=js&"
import style0 from "./LabVideo.vue?vue&type=style&index=0&id=1283d173&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports